import { FormattedMessage as FM } from "react-intl";

import InheritedRow from "./InheritedRow";
import { getInheritedFields } from "../helpers/hotelDefaults";

function HotelDefaultsList({ melhous, defaults }) {
  const inherited = getInheritedFields(melhous, defaults);
  return (
    <div className="rounded-lg border border-neutral-200 bg-white p-3 shadow-sm">
      <p className="text-sm font-semibold text-neutral-700">
        <FM id="melhous.dash.inherited.title" />
      </p>
      {inherited.length > 0 ? (
        <ul className="mt-1 divide-y divide-neutral-100">
          {inherited.map(({ name, value }) => (
            <InheritedRow key={name} name={name} value={value} />
          ))}
        </ul>
      ) : (
        <p className="mt-1 text-xs text-neutral-500">
          <FM id="melhous.dash.inherited.empty" />
        </p>
      )}
    </div>
  );
}

export default HotelDefaultsList;
